import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DataConvertersManager } from './converters/data-converters.manager'
import { Observable } from 'rxjs'
import { IHttpOptions } from '../models/http-options'
import { map } from 'rxjs/operators'
import { isEmpty, isEmptyObject } from '@adex/shared/utils/data'


@Injectable()
export class CustomHttpClient {

  constructor(private readonly http: HttpClient, private readonly converterManager: DataConvertersManager) {
  }

  public get<R>(url: string, options?: IHttpOptions): Observable<R> {
    const converter = this.converterManager.getConverter<any, R>(url)
    return this.http.get<any>(url, options).pipe(
      map(obj => !CustomHttpClient.isEmptyResponse(obj) ? converter.toInside(obj) : obj)
    )
  }

  public post<R, B>(url: string, body: B, options?: IHttpOptions): Observable<R> {
    const converter = this.converterManager.getConverter<object, B>(url)
    const data = !isEmpty(body) ? converter.toOutside(body) : body
    return this.http.post<any>(url, data, options).pipe(
      map(obj => !CustomHttpClient.isEmptyResponse(obj) ? converter.toInside(obj) : obj)
    ) as any
  }

  private static isEmptyResponse(response: any): boolean {
    if (isEmptyObject(response)) return true
    const keys = Object.keys(response)
    return keys.length === 1 && (keys[0] === 'errors' || keys[0] === 'error')

  }
}
